import { useTranslation } from "react-i18next";

import { CloseButton } from "@aviary";
import { ProductSearch } from "@emerson/components/ProductSearch/ProductSearch";
import { l } from "@emerson/locales/i18n";

import * as styles from "./SearchModal.styles";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const SearchModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  const combinedStyles = [styles.searchModal.base, isOpen && styles.searchModal.active];

  return (
    <div css={combinedStyles}>
      <CloseButton onClick={onClose} aria-label={t(l.header.Close)} />
      <ProductSearch hideFilterTags />
    </div>
  );
};
export { SearchModal };
